import React from 'react';
import { Dialog, DialogActions, Button, Grid, DialogContent, DialogTitle } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { getAudioVolume } from '../../../utilities/storageUtilities';
import { theme } from '../../../App/MuiTheme';
import { NavLink } from 'react-router-dom';
import { trackEvent, AnalyticsConstants } from '../../../utilities/analyticsUtilities';
import DialogCloseButton from '../../buttons/DialogCloseButton';

const styles = theme => ({
    videoViewerContainer: {
        [theme.breakpoints.down('xl')]: {
            width: "100%"
        }
    },
    videoViewer: {
        [theme.breakpoints.down('xl')]: {
            width: "100%"
        }
    },
    dialogTitle: {
        padding: "10px 24px",
        '.MuiButtonBase-root': {
            padding: "5px",
            top: "5px"
        }
    }
});

const ctaText = 'REMOVE WATERMARK';

class VideoViewerDialog extends React.Component {
    state = {}

    render() {
        const { src, classes, open, showRemoveWatermark, iframe, onClose } = this.props;

        return (
            <Dialog
                onClose={onClose}
                maxWidth='md'
                fullWidth={true}
                open={open}
            >
                <DialogTitle className={classes.dialogTitle}>
                    <DialogCloseButton onClick={onClose} />
                </DialogTitle>
                <DialogContent>
                    <Grid
                        container
                        direction='column'
                        justifyContent='center'
                        alignItems='center'
                    >
                        <Grid className={classes.videoViewerContainer}>
                            {!iframe ?
                                <video
                                    width='912'
                                    height='513'
                                    controls
                                    autoPlay
                                    onLoadStart={(e) => e.target.volume = getAudioVolume()}
                                >
                                    <source src={src} type='video/mp4' />
                                    Your browser does not support this video.
                                </video>
                                :
                                <iframe
                                    src={src}
                                    width='912'
                                    height='513'
                                    frameBorder='0'
                                    allow='autoplay; fullscreen'
                                    className={classes.videoViewer}
                                    allowFullScreen
                                    title='video'
                                ></iframe>
                            }
                        </Grid>
                        <Grid hidden={!showRemoveWatermark}>
                            <NavLink
                                to='/plans'
                                style={{ textDecoration: 'none' }}
                                onClick={() => {
                                    trackEvent('Clicked CTA', {
                                        category: AnalyticsConstants.ACQUISITION_CATEGORY,
                                        color: 'red',
                                        destination: 'plans',
                                        location: 'video viewer dialog',
                                        text: ctaText,
                                        type: 'button'
                                    });
                                }}
                            >
                                <Button
                                    size='large'
                                    color='primary'
                                    variant='contained'
                                    style={{ marginTop: theme.spacing(4) }}
                                >
                                    {ctaText}
                                </Button>
                            </NavLink>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(VideoViewerDialog, styles);